import type { ExternalTableSchema } from '@packages/table-builder';

export const securitiesTable: ExternalTableSchema = {
  metadata: {
    title: 'Shares',
    entity: 'Securities',
  },

  dataSource: {
    endpoint: '/api/cap-table/api/app/securities',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },

    filters: [
      {
        name: 'SecurityType',
        placeholder: 'Security Type',
        type: 'select',
        options: [
          { label: 'Service Provider', value: 1 },
          { label: 'Non Service Provider', value: 2 },
        ],
      },
      {
        name: 'Status',
        placeholder: 'Status',
        type: 'select',
        options: [
          { label: 'Draft', value: 1 },
          { label: 'Published', value: 2 },
        ],
      },
      {
        name: 'StockClassId',
        placeholder: 'Stock Class',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/cap-table/api/app/stock-class/current-issuer-stock-class-list',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'SourceType',
        placeholder: 'Source Type',
        type: 'select',
        options: [
          { label: 'Security Issuance', value: 1 },
          { label: 'Convertible', value: 2 },
          { label: 'Warrant', value: 3 },
        ],
      },
    ],
  },

  columns: [
    {
      field: 'certificateNumber',
      header: 'Certificate #',
      width: 140,
      sortable: true,
      visibility: 'locked',
    },
    {
      field: 'participantName',
      header: 'Holder',
      width: 180,
      sortable: true,
    },
    {
      field: 'stockClassName',
      header: 'Stock Class',
      width: 140,
      sortable: true,
    },
    {
      field: 'securityTypeName',
      header: 'Type',
      width: 120,
      sortable: true,
    },
    {
      field: 'statusName',
      header: 'Status',
      type: 'badge',
      width: 120,
      sortable: true,
      align: 'center',
      badge: {
        statusMap: {
          Draft: 'info',
          Published: 'success',
        },
        defaultVariant: 'default',
      },
    },
    {
      field: 'quantity',
      header: 'Quantity',
      type: 'number',
      width: 100,
      sortable: true,
      align: 'right',
    },
    {
      field: 'sharePrice',
      header: 'Share Price',
      type: 'currency',
      // format: { decimals: 8 },  The format: { decimals: 8 } approach makes sense for the long-term fix when the backend sends precision metadata.
      width: 140,
      skipFormatDefault: true,
      sortable: true,
      align: 'right',
    },
    {
      field: 'issueDate',
      header: 'Issue Date',
      type: 'date',
      width: 120,
      sortable: true,
    },
    {
      field: 'vestingTemplateName',
      header: 'Vesting Template',
      width: 160,
      sortable: true,
    },
    {
      field: 'rule144Restricted',
      header: 'Rule 144',
      type: 'badge',
      width: 90,
      sortable: true,
      align: 'center',
      conditionalValues: { true: 'Yes', false: 'No' },
      badge: {
        statusMap: { Yes: 'success', No: 'error' },
      },
    },
    {
      field: 'sourceTypeName',
      header: 'Source Type',
      width: 130,
      sortable: true,
    },

    // ── Column-picker only ──────────────────────────────────────────────
    {
      field: 'boardApprovalDate',
      header: 'Board Approval Date',
      type: 'date',
      width: 160,
      sortable: true,
      visibility: 'picker',
    },
    {
      field: 'vestingCommencementDate',
      header: 'Vesting Start Date',
      type: 'date',
      width: 160,
      sortable: true,
      visibility: 'picker',
    },
    {
      field: 'cancelledQuantity',
      header: 'Cancelled Qty',
      type: 'number',
      width: 120,
      sortable: true,
      align: 'right',
      visibility: 'picker',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_SECURITIES', label: 'View' },
      { id: 'EDIT_SECURITIES', label: 'Edit' },
      { id: 'PUBLISH_SECURITIES', label: 'Publish' },
      { id: 'DELETE_SECURITIES', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_SECURITIES',
        label: 'Issue Securities',
        icon: 'add_circle_outline',
      },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_SECURITIES', label: 'Download Template' }],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [{ id: 'IMPORT_SECURITIES', label: 'Import Bulk XLS' }],
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Securities', resizable: true, reorderable: true },
  },
};
